import PropTypes from "prop-types"
import React from "react"

import { useTranslation } from "../../../i18n/translate"
import { DownloadModel } from "../../../model/downloadModel"
import FileDownload from "./file-download/file-download"
import "./file-downloads.sass"

export const groupDownloadsByName = (dl, t) => {
  const res = {}
  const downloadsGroupedByName = []

  dl.forEach((d) => {
    if (!d || !d.pdf_file || !d.pdf_file.fileName) {
      return
    }

    const key = t(d.pdf_file.fileName.key)

    if (!res[key]) {
      res[key] = []
    }

    res[key].push(d)
  })

  for (const resKey in res) {
    downloadsGroupedByName.push(res[resKey])
  }

  return downloadsGroupedByName
}


const FileDownloads = ({
  groupedDownloads,
  downloads,
  fileStyle,
  fullWidth,
}) => {
  const { t } = useTranslation()

  if (downloads && groupedDownloads) {
    throw new Error(
      "FileDownloads accepts only one of [groupedDownloads, downloads] props",
    )
  }

  if (downloads) {
    const downloadsGroupedByName = groupDownloadsByName(downloads, t)

    return (
      <div className={"_fp-file-downloads"}>
        {downloadsGroupedByName &&
          downloadsGroupedByName
            .sort((a, b) =>
              t(a[0].pdf_file.fileName.key).localeCompare(
                t(b[0].pdf_file.fileName.key),
              ),
            )
            .map((dlGroup, index) => {
              return (
                <FileDownload
                  fullWidth={fullWidth}
                  key={`file-download-${index}`}
                  fileStyle={fileStyle}
                  downloadGroup={dlGroup}
                />
              )
            })}
      </div>
    )
  }

  if (groupedDownloads) {
    return (
      <div className={"_fp-file-downloads"}>
        {groupedDownloads.map((groupedDownload) => {
          const downloadsGroupedByName = groupDownloadsByName(
            groupedDownload.downloads,
            t,
          )
          if (downloadsGroupedByName.length === 0) {
            return null
          }

          return (
            <div className={"_fp-file-downloads__section"}>
              <div className="_fp-file-downloads__section__header _fp-heading-6">
                {groupedDownload.titleTranslatedString}
              </div>

              <div className="_fp-file-downloads__section__content">
                {downloadsGroupedByName &&
                  downloadsGroupedByName
                    .sort((a, b) =>
                      t(a[0].pdf_file.fileName.key).localeCompare(
                        t(b[0].pdf_file.fileName.key),
                      ),
                    )
                    .map((dlGroup, index) => {
                      return (
                        <FileDownload
                          fullWidth={fullWidth}
                          key={`file-download-${index}`}
                          fileStyle={fileStyle}
                          downloadGroup={dlGroup}
                        />
                      )
                    })}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  throw new Error(
    "FileDownloads requires one of [groupedDownloads, downloads] props",
  )
}

FileDownloads.propTypes = {
  downloads: PropTypes.arrayOf(PropTypes.instanceOf(DownloadModel)),
  fileStyle: PropTypes.oneOf(["gray", "white"]),
  fullWidth: PropTypes.bool,
}

FileDownloads.defaultProps = {
  fileStyle: "gray",
}

export default FileDownloads
